const UseCases = () => {
  const useCases = [
    {
      icon: 'ri-team-fill',
      title: 'Meetings',
      description: 'Capture every detail from team meetings, client calls, and brainstorming sessions without missing a beat.',
      color: 'from-teal-500 to-green-500'
    },
    {
      icon: 'ri-book-open-fill',
      title: 'Lectures',
      description: 'Record and transcribe educational content, making it easy to review and study later with AI-generated summaries.',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: 'ri-mic-fill',
      title: 'Interviews',
      description: 'Focus on the conversation while AI captures and organizes everything, perfect for journalists and researchers.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-lightbulb-flash-fill',
      title: 'Brainstorming',
      description: 'Never lose a great idea again. Record creative sessions and get organized notes with key insights highlighted.',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: 'ri-headphone-fill',
      title: 'Podcasts',
      description: 'Generate accurate transcripts and show notes for your podcast episodes automatically with AI assistance.',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: 'ri-user-voice-fill',
      title: 'Personal Memos',
      description: 'Quickly capture thoughts, reminders, and voice notes that are automatically transcribed and searchable.',
      color: 'from-cyan-500 to-blue-500'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">Perfect for Every Scenario</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From professional meetings to personal memos, AI Note Taker adapts to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 border border-slate-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className={`w-14 h-14 bg-gradient-to-br ${useCase.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${useCase.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">{useCase.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{useCase.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;